import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobFilter } from '../jobs/models/job-filter';
import { JobsStore } from '../jobs/store/jobs-store.service';
import { AppStore } from '../shared/store/lookup-store.service';
import { FormGroup } from '@angular/forms';
import {
  addContactUsForm,
  contactUsValidationMessages,
} from '../shared/forms/contact-us.form';
import { getControlValidationMessage } from '../shared/helpers/form-helper';
import { AppSharedService } from '../shared/services/app.service';
import { UiStateStore } from '../shared/store/ui-state-store.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  contactUsForm: FormGroup;
  isFormSubmitted = false;
  constructor(
    public lookupStore: AppStore,
    private router: Router,
    private jobStore: JobsStore,
    private appService: AppSharedService,
    private uiState: UiStateStore,
  ) {
    this.contactUsForm = addContactUsForm();
  }

  ngOnInit(): void {}

  onTrendingKeywordClicked(trendingKeyword: string): void {
    let jobFilter = new JobFilter();
    jobFilter.keyword = trendingKeyword;

    this.jobStore.loadSearchResults(jobFilter);
    this.router.navigate(['/search-jobs']);
  }

  handleContactUsSubmission = () => {
    this.isFormSubmitted = true;

    if (!this.contactUsForm.valid) {
      return;
    }

    this.appService.submitContactUsDetails(this.contactUsForm.value).subscribe(resp => {
      if(resp) {
        this.uiState.setSuccess('Your details has been submitted successfully.')
      } else {
        this.uiState.setError('Unable to save your details. Please try again.')
      }
    })
  };

  getValidationMessage = (controlName: string) => {
    var controlErrors = this.contactUsForm.controls[controlName].errors;

    return getControlValidationMessage(
      controlName,
      controlErrors,
      contactUsValidationMessages
    );
  };

  canShowValidation = (controlName: string): boolean => {
    return (this.contactUsForm.controls[controlName].touched && this.contactUsForm.controls[controlName].invalid) || this.isFormSubmitted;
  }
}
